import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardContent, CardHeader, Divider, Typography, } from "@mui/material";
import { PlayerView } from "../players/PlayerView";
import { PlayerMatchStatGlyphs } from "../stats/PlayerMatchStatGlyphs";
export const SquadCardWithStats = ({ team, players, getPlayerStat, }) => {
    return (_jsxs(Card, { children: [_jsx(CardHeader, { title: _jsx(Typography, { align: "center", variant: "subtitle2", children: team.name }) }), _jsxs(CardContent, { children: [_jsx(Divider, { sx: { marginBottom: 2 } }), players.length === 0 ? (_jsx(Typography, { variant: "body2", textAlign: "center", color: "text.secondary", sx: { py: 2 }, children: "No players!" })) : (players.map((player, index) => {
                        const stat = getPlayerStat(player.id);
                        return (_jsxs(Box, { sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                px: 2,
                                py: 1,
                                bgcolor: index % 2 === 0 ? "white" : "#f9f9f9",
                                borderRadius: 1,
                            }, children: [_jsx(PlayerView, { player: player, variant: "subtitle1" }), _jsx(PlayerMatchStatGlyphs, { goalsScored: stat?.goalsScored, yellowCards: stat?.yellowCards, redCards: stat?.redCards })] }, player.id));
                    }))] })] }));
};
